import React from 'react'
import PropTypes from 'prop-types'

import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

const BrandImageListItem = (props) => {
  const {
    backgroundColour,
    callbacks: { launchModalFn },
    imageBackgroundSize = 'contain',
    imageUrl,
    fileName,
    title,
  } = props

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px solid',
        fontSize: 'small',
        justifyContent: 'space-between',
        lineHeight: 1.3,
        padding: 'large',
      }}
      onClick={() => launchModalFn()}
      showAngleIcon
    >
      {imageUrl && (
        <Image
          backgroundSize={imageBackgroundSize}
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor', marginRight: 'large' }}
          height={60}
          style={{ backgroundColor: backgroundColour && `#${backgroundColour}` }}
          url={imageUrl}
          width={100}
        />
      )}

      <Box flexDirection="column">
        <Text width="fit-content">
          {title}
        </Text>

        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          maxWidth="80%"
          variant="ellipsis"
        >
          {imageUrl ? fileName : 'Not Uploaded'}
        </Text>
      </Box>
    </ListItem>
  )
}

BrandImageListItem.propTypes = {
  backgroundColour: PropTypes.string,
  callbacks: PropTypes.shape({
    launchModalFn: PropTypes.func.isRequired,
  }).isRequired,
  fileName: PropTypes.string,
  imageBackgroundSize: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default BrandImageListItem
